export default "__VITE_ASSET__30VDuHkE__"